import { useEffect, useState } from "react";
function ImageSlider() {
  const images = [
    "/images/app/slide1.png",
    "/images/app/slide2.png",
    "/images/app/slide3.png",
  ];

  const [current, setCurrent] = useState(0);

  // Auto slide
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="slider">
      {/* Image */}
      <img
        src={images[current]}
        alt="slide"
        className="slide-image"
      />

      {/* Navigation */}
      <button className="nav prev" onClick={() =>
        setCurrent((current - 1 + images.length) % images.length)
      }>
        ❮
      </button>

      <button className="nav next" onClick={() =>
        setCurrent((current + 1) % images.length)
      }>
        ❯
      </button>

      {/* Dots */}
      <div className="dots">
        {images.map((_, index) => (
          <span
            key={index}
            className={`dot ${index === current ? "active" : ""}`}
            onClick={() => setCurrent(index)}
          />
        ))}
      </div>
    </div>
  );
}

export default ImageSlider;
